// Install: npm install react-flow-renderer framer-motion
import React, { useState, useMemo } from "react";
import ReactFlow, { Background, Controls } from "react-flow-renderer";
import "./ConditionalFlowDiagram.css";

const initialNodes = [
  { id: "decision", data: { label: "age ≥ 18?" }, position: { x: 250, y: 50 }, style: { width: 150 } },
  { id: "allow", data: { label: "Доступ разрешён" }, position: { x: 100, y: 200 }, style: { width: 150 } },
  { id: "denyPerm", data: { label: "Доступ запрещён:\nнет разрешения" }, position: { x: 400, y: 200 }, style: { width: 200 } },
  { id: "denyAge", data: { label: "Доступ запрещён:\nслишком молоды" }, position: { x: 250, y: 350 }, style: { width: 200 } },
];

const initialEdges = [
  { id: "e1", source: "decision", target: "allow", label: "True & has_permission", type: "smoothstep" },
  { id: "e2", source: "decision", target: "denyPerm", label: "True & !has_permission", type: "smoothstep" },
  { id: "e3", source: "decision", target: "denyAge", label: "False", type: "smoothstep" },
];

const ConditionalFlowChart = () => {
  const [age, setAge] = useState(17);
  const [hasPermission, setHasPermission] = useState(false);

  // Determine active node and edge
  const outcome = age >= 18 ? (hasPermission ? "allow" : "denyPerm") : "denyAge";
  const activeEdge = age >= 18 ? (hasPermission ? "e1" : "e2") : "e3";

  // Style nodes
  const nodes = useMemo(
    () => initialNodes.map(n => ({
      ...n,
      style: {
        ...n.style,
        background: n.id === outcome ? "#3f51b5" : "#f5f5f5",
        color: n.id === outcome ? "#fff" : "#000",
        borderColor: n.id === outcome ? "#303f9f" : "#ccc",
      },
    })),
    [outcome]
  );

  // Style edges
  const edges = useMemo(
    () => initialEdges.map(e => ({
      ...e,
      animated: e.id === activeEdge,
      style: { stroke: e.id === activeEdge ? "#3f51b5" : "#aaa" },
      labelStyle: {
        fill: e.id === activeEdge ? "#3f51b5" : "#555",
        fontWeight: e.id === activeEdge ? "bold" : "normal",
      },
    })),
    [activeEdge]
  );

  return (
    <div className="conditional-flow-chart">
      <h3>Интерактивная демонстрация if/else ветвлений</h3>

      <div className="controls">
        <label>
          Возраст:
          <input type="number" value={age} onChange={e => setAge(Number(e.target.value))} />
        </label>
        <label>
          <input
            type="checkbox"
            checked={hasPermission}
            onChange={e => setHasPermission(e.target.checked)}
          />
          Есть доступ?
        </label>
      </div>

      <div className="flow-container">
        <ReactFlow nodes={nodes} edges={edges} fitView attributionPosition="bottom-left">
          <Background gap={16} color="#ddd" />
          <Controls showInteractive={false} />
        </ReactFlow>
      </div>

      <div className="flow-description">
        <p>
          Эта диаграмма иллюстрирует ветвление алгоритма на основании двух условий:
          сначала проверяется, является ли пользователь совершеннолетним (age ≥ 18),
          затем — есть ли у него разрешение (has_permission).
          Если оба условия истинны, доступ разрешается. Если возраст соответствует,
          но отсутствует разрешение, доступ запрещается по причине отсутствия
          привилегий. Если же возраст меньше 18, доступ запрещается из-за
          недостаточного возраста.
        </p>
      </div>
    </div>
  );
};

export default ConditionalFlowChart;